/* Berry Blush Product Page: variant/size picker + thumbnail gallery */

(function () {
  'use strict';

  // Thumbnail gallery: click a thumb to swap the main image
  document.querySelectorAll('[data-product-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      const fullSrc = thumb.dataset.fullSrc;
      const mainImageWrap = document.querySelector('[data-product-main-image]');
      const mainImg = mainImageWrap ? mainImageWrap.querySelector('img') : null;
      if (mainImg && fullSrc) {
        mainImg.src = fullSrc;
      }
    });
  });

  // Variant/size picker
  document.querySelectorAll('[data-variant-selector]').forEach(function (selector) {
    const buttons = Array.from(selector.querySelectorAll('[data-variant-option]'));
    const addToCartBtn = document.querySelector('[data-add-to-cart]');
    const priceEl = document.querySelector('[data-product-price]');
    const labelEl = document.querySelector('[data-add-to-cart-label]');
    const mainImageWrap = document.querySelector('[data-product-main-image]');
    const mainImg = mainImageWrap ? mainImageWrap.querySelector('img') : null;

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;

        buttons.forEach(function (b) {
          b.removeAttribute('data-active');
          b.style.borderColor = '#ddd';
          b.style.background = '#fff';
        });
        btn.setAttribute('data-active', 'true');
        btn.style.borderColor = '#c2185b';
        btn.style.background = '#fdecf2';

        const variantId = btn.dataset.variantId;
        const variantPrice = btn.dataset.variantPrice;
        const variantImage = btn.dataset.variantImage;

        if (addToCartBtn) addToCartBtn.dataset.variantId = variantId;
        if (priceEl && variantPrice) priceEl.textContent = variantPrice;
        if (labelEl && variantPrice) labelEl.innerHTML = 'Add to Cart &mdash; ' + variantPrice;
        if (mainImg && variantImage) mainImg.src = variantImage;
      });
    });
  });
})();
